import { SellerRepository } from "../../../repositories/sellerRepository"

export class DownloadSellersUseCase {
	private _sellerRepository: SellerRepository

	constructor({ SellerRepository }: { SellerRepository: SellerRepository }) {
		this._sellerRepository = SellerRepository
	}

	public async exec(): Promise<Blob> {
		return this._sellerRepository.downloadSellers()
	}
}
